import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const lifecycleDefinition: ResourceDefinition = {
  title: 'Lifecycles',
  nameSingular: 'lifecycle',
  namePlural: 'lifecycles',
  className: 'Lifecycle',
  mainIdentifier: 'name',
  slug: 'taxonomies/lifecycles',
  path: 'lifecycles',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (lifecycle) => ({
        type: ActionType.Link,
        link: {
          path: `${lifecycleDefinition.path}/${lifecycle.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (lifecycle) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: lifecycle,
          definition: lifecycleDefinition
        }
      })
    }
  ]
}
